module.exports = __webpack_public_path__ + "static/media/Barnier.30d77f20.jpg";